export default __webpack_public_path__ + "static/vacations-preview-disney-1-345381502a5bbeb8a3d2543f54c33c7b.jpg";